module.exports = __webpack_public_path__ + "static/media/Halcyon_light_mode.16193b1a.png";